import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Modal, ModalBody, ModalTitle } from "react-bootstrap";
import { bindActionCreators } from "redux";
import { Actions } from "../../../Action";
import { Grid, Button } from "@mui/material";
import "./SharedFolderCMModal.Styles.css";
import { fetchDocumentsForGDRIVE, updateGdriveAttrs } from "../../../API/api";
import { handleError } from "../../../utils";
import VizParagraph from "../../VizParagraph/VizParagraph";
import VizHeader from "../../VizHeader/VizHeader";
import VizButton from "../../VizButtons/VizButton";
import { toast } from "react-toastify";

export default function SharedFolderCMModal() {
	// const useStyles = makeStyles(theme => ({
	// 	root: {
	// 	  margin: theme.spacing(1)
	// 	},
	// 	in: {
	// 	  padding: 8
	// 	}
	//   }));
	const dispatch = useDispatch();
	const { advanceFilterModalToggle, getgdriveDocumentsData, isLoadingSharedCMData,getFolderNameForGDriveDocs, getFrequencyNameForGoogleDrive } = bindActionCreators(Actions, dispatch);
	const modalState = useSelector((state) => state.domain);
	const sharedFolderData = useSelector((state) => state.sharedFolderCMReducer);
	const [getFolderName, setFolderName] = useState(sharedFolderData.folderName);
	const [freqId, getFreqId] = useState(0);
	const [getFrequencyName, setFrequencyName] = useState(sharedFolderData.frequencyName !== '' ? sharedFolderData.frequencyName : '')

	const onChangeGetFolderName = (e) => {
		setFolderName(e.target.value)
	}

	const getFrequencyId = (e) => {
		setFrequencyName(e.target.value);
		let newArr = sharedFolderData.frequency.filter((obj)=>{
			if(obj.name === e.target.value)
			{
				return obj;
			}
		})
		getFreqId(newArr[0].id);
	}

	const onClickSubmitData = () => {
		let payload = {
			id: sharedFolderData.id,
			folderName: getFolderName,
			frequency: freqId,
			archive: false
		}
		// {
		// 	"id": 31,
		// 	"folderName": "sharedFolderLinkk",
		// 	"frequency": 1,
		// 	"rchive": false
		// }
		updateGdriveAttrs(payload).then((res) => {
			if (res===undefined) return;
			if (res.data.success === true || res.data.data !== undefined) {
				advanceFilterModalToggle({ bool: false, value: "" })
				isLoadingSharedCMData(true);
				toast.success(submitSuccessToast(),{
					position: toast.POSITION.TOP_RIGHT,
				})
				fetchDocumentsForGDRIVE().then((res) => {
					if (res===undefined) return;
					if (res.data.success === true || res.data.data !== undefined) {
						getgdriveDocumentsData(res.data.data);
						isLoadingSharedCMData(false);
					}
				}).then((err) => handleError(err))
			}
		}).catch((err) => handleError(err))
	}

	const onClickCancelButton = () => {
		advanceFilterModalToggle({ bool: false, value: "" })
		// getFrequencyNameForGoogleDrive('')
		// getFolderNameForGDriveDocs('')
	}

	const submitSuccessToast = () => {
		return (
		  <>
			<span style={{ fontSize: "12px" }}>
			  Parameters have been updated successfully.
			</span>
		  </>
		);
	  };


	  useEffect(()=>{
		if(getFrequencyName === sharedFolderData.frequencyName )
		{
			let newAr = sharedFolderData.frequency.filter((obj)=>{
				if(obj.name === sharedFolderData.frequencyName)
				{
					return obj;
				}
			})
			getFreqId(newAr[0].id)
		}
	  },[freqId])

	return (
		<>
			<Modal show={modalState.modalState}
				onHide={() => onClickCancelButton()} centered={true}
				backdrop="static"
				size={"md"}>
				<Modal.Header className="modalheader modalHeaderBackground" closeButton closeVariant="white">
					<ModalTitle className="modalTitle">
						<i style={{fontSize:'16px',}} class="fa fa-pencil-square-o" aria-hidden="true"></i>&nbsp;&nbsp;&nbsp;Edit Folder Content
					</ModalTitle>
				</Modal.Header>
				<ModalBody className="modalRecentRatingsBody">
					<Grid container spacing={2} alignItems="baseline">
						<Grid item xs={4}>
							{/* <VizHeader type={5} isBold={true}> */}
							<VizParagraph type={5} weight={1}>
								Folder Name:
							</VizParagraph>
						</Grid>
						<Grid item xs={5}>
							<input value={getFolderName} onChange={(e) => onChangeGetFolderName(e)} type="text" style={{ height: '24px', fontSize: '14px' }}></input>
						</Grid>
					</Grid>
					<Grid paddingTop={1} container spacing={2} alignItems="baseline">
						<Grid item xs={4}>
							<VizParagraph type={5} weight={1}>
								Update Frequency:
							</VizParagraph>
						</Grid>
						<Grid item xs={5}>
							<select value={getFrequencyName} style={{ fontWeight:'normal', textTransform:'capitalize',width: '50%', fontSize: '14px', outline: 'none' }} onChange={(e) => getFrequencyId(e)} >
								{/* <option>Once</option></select> */}
								{sharedFolderData.frequency.length > 0 &&
									sharedFolderData.frequency.map((obj) => {
										return (
											<option style={{ fontSize: '14px' }}>{obj.name}</option>
										)
									})
								}
							</select>
						</Grid>
					</Grid>
					<Grid paddingTop={1} justifyContent="flex-end" container spacing={2} alignItems="baseline">
						<div style={{ margin: '5px' }}>
							<VizButton size={3} type={"Primary"} onClick={onClickSubmitData}>Submit</VizButton>
						</div>
						<VizButton size={3} type={"Tertiary"} onClick={onClickCancelButton}>Cancel</VizButton>
					</Grid>
				</ModalBody>
			</Modal>
		</>
	)
}